// export const  API_BASE_URL = "http://127.0.0.1:8000/api";
export const  API_BASE_URL = "https://admin.locknpay.com/api";

// export const IMG_BASE_URL = "http://127.0.0.1:8000/storage"
export const IMG_BASE_URL = "https://admin.locknpay.com/storage"